import { Link } from 'react-router-dom';
import './Showgames.css';
import { ProgressBarCourses } from '../content/progresbars/ProgressBarCourses';
import gamerules from '../imagesHome/game-rules.png';
import choseaccount from '../imagesHome/game02.png';
import accountsplan from '../imagesHome/accountsplan.png';
import chaptericon from '../imagesHome/chapter_icon.png';

const Showgames = () => {
  return (
    <div className="games-container">
      <div className="games-title">
        <div>Jocuri interactive</div>
        <div className='games-subtitle'>Învață contabilitate prin exerciții practice</div>
      </div>

      <div className='games-list'>

        {/* Joc 1 */}
        <div className='game-card-wrapper'>
          <div className='game-header'>
            <img src={gamerules} alt='gamerules' className="game-image-fc-g" />
            <div className='game-header-text'>
              <div className='game-title'>Cum funcționează conturile?</div>
              <div className='game-subtitle'>Joacă și învață prin exemple reale</div>
            </div>
          </div>

          <div className='game-body'>
            <div className='game-progress-container'>
              <div className='game-progress-bar'>
                <ProgressBarCourses progress={20} />
              </div>

              <div className="game-badges">
                <div className="game-badge">
                  <span>🎯</span><span className='badge-green'> 10 întrebări</span>
                </div>
                <div className="game-badge">
                  <span>📊</span><span className='badge-blue'> Rezultate în timp real</span>
                </div>
              </div>
            </div>

            <div className='game-divider'></div>

            <div className='game-button-container'>
              <Link to={'/LessonsGameFunctionalRules'} className="game-button-fr">
                <div className="game-button-content">
                  <img src={chaptericon} className='game-button-icon' alt='start' />
                  <span className='game-button-text'>Joacă</span>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className='game-section-divider'></div>

        {/* Joc 2 */}
        <div className='game-card-wrapper'>
          <div className='game-header'>
            <img src={choseaccount} alt='choseaccount' className="game-image-ta-g" />
            <div className='game-header-text'>
              <div className='game-title'>Identifică tipul contului</div>
              <div className='game-subtitle'>Active, pasive, venituri și cheltuieli</div>
            </div>
          </div>

          <div className='game-body'>
            <div className='game-progress-container'>
              <div className='game-progress-bar'>
                <ProgressBarCourses progress={40} />
              </div>

              <div className="game-badges">
                <div className="game-badge">
                  <span>🧠</span><span className='badge-purple'> 15 întrebări</span>
                </div>
                <div className="game-badge">
                  <span>📋</span><span className='badge-orange'> Clasificare rapidă</span>
                </div>
              </div>
            </div>

            <div className='game-divider'></div>

            <div className='game-button-container'>
              <Link to={'/LessonsGameTipeAccount'} className="game-button-ta">
                <div className="game-button-content">
                  <img src={chaptericon} className='game-button-icon' alt='start' />
                  <span className='game-button-text'>Joacă</span>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className='game-section-divider'></div>

        {/* Joc 3 */}
        <div className='game-card-wrapper'>
          <div className='game-header'>
            <img src={accountsplan} alt='accountsplan' className="game-image-ap-g" />
            <div className='game-header-text'>
              <div className='game-title'>Planul de conturi</div>
              <div className='game-subtitle'>Exersează codurile conturilor</div>
            </div>
          </div>

          <div className='game-body'>
            <div className='game-progress-container'>
              <div className='game-progress-bar'>
                <ProgressBarCourses progress={60} />
              </div>

              <div className="game-badges">
                <div className="game-badge">
                  <span>📘</span><span className='badge-green'> 12 coduri</span>
                </div>
                <div className="game-badge">
                  <span>🚀</span><span className='badge-blue'> Timp limitat</span>
                </div>
              </div>
            </div>

            <div className='game-divider'></div>

            <div className='game-button-container'>
              <Link to={'/LessonsGameAccountsPlan'} className="game-button-ap">
                <div className="game-button-content">
                  <img src={chaptericon} className='game-button-icon' alt='start' />
                  <span className='game-button-text'>Joacă</span>
                </div>
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Showgames;
